import React from "react";

// Original LIF mark — geometric monogram, editorial monospace vibe
// Circles mark the "coin" points; the crossbar of L extends into F for continuity
export const Logo = ({ size = 28, accent = "#00E5FF", fg = "#F4F4F5" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="LIF logo"
  >
    {/* Outer thin square */}
    <rect
      x="0.75"
      y="0.75"
      width="38.5"
      height="38.5"
      rx="6"
      fill="none"
      stroke="rgba(255,255,255,0.14)"
      strokeWidth="0.75"
    />
    {/* L */}
    <path
      d="M9 10 V28 H17"
      stroke={fg}
      strokeWidth="1.75"
      fill="none"
      strokeLinecap="square"
    />
    {/* I */}
    <path
      d="M20 10 V28"
      stroke={fg}
      strokeWidth="1.75"
      strokeLinecap="square"
    />
    {/* F */}
    <path
      d="M24 28 V10 H31 M24 19 H29.5"
      stroke={fg}
      strokeWidth="1.75"
      fill="none"
      strokeLinecap="square"
    />
    {/* Accent dot — the "capital" */}
    <circle cx="33" cy="8" r="1.6" fill={accent} />
  </svg>
);

export default Logo;
